const CommonColorUtils = {
    primaryMainBlue: "#2E65F3",
    primaryGrey600: "#6F727A",
    primaryGrey300: "#EBECEF",
    primaryGrey500: "#9CA1AD",
    primaryGrey700: "#232325",
    primaryMainBlueDisabledColor: "#86A6F8",
    primaryGrey100: "#F7F7F9",
    primaryKWhite: "#FAFBFF",
    primaryErrorDarkColor: "#F32D2D",
    primarySuccessLightGreen: "#DCFBEA",
    primarySuccessDarkGreen: "#249F5D",
    primaryErrorLightRed: "#FFDBDB",
    kSecondaryAlert300: "#FFB545",
    kWhiteShade: "#FFF5E5",
    kPrimaryPureWhite: "#FFFFFF",
    kPrimeGreenDarkShade: "#DFECE9",
    kPrimeGreenDarker: "#3A5F58",
    kPrimePurpleLightShade: "#E5D6F5",
    kPrimePurpleDarkShade: "#5A2391",
    krtoTextColor: "#913400",
    krtoBackgroundColor: "#F5E3D9",
    kSecondaryAlert500: "#F59300",
    kSelectedBackgroundColor: "#EAF5FF",
    selectedFilterLabelBackgroundColor: "#D1E6FA4D",
    kborderColorPortal:"#E0E2E6",
    kMenuHoverBg:"#F7F7F7",
    noResultsTextColor:"#9E9E9E",
    kBorderColorComboSearchBox:"#dcdcdc"
};
export default CommonColorUtils;
